/* Speediance option guard.
   Loaded only for products carrying custom.hide_invalid_options.

   Two jobs:
   1. Before variant-selects reads the form, snap any option group to the right
      of the one just changed onto a value that a real variant pairs with the
      new selection. Without this, changing Model posts a combination that does
      not exist and the section re-renders with no price and no colours.
   2. Keep the impossible values out of view after every re-render.

   Everything is delegated from document, because the Section Rendering API
   replaces the picker subtree and any listener or observer bound to it dies. */
(function () {
  var STAMP = '20260918b';
  if (document.documentElement.dataset.bmOptGuard === STAMP) return;
  document.documentElement.dataset.bmOptGuard = STAMP;

  function scopeOf(node) {
    return (node && node.closest && (node.closest('.variant-selects__wrapper') || node.closest('.shopify-section'))) || null;
  }

  function readMatrix(scope) {
    var el = scope && scope.querySelector('[data-bm-variant-matrix]');
    if (!el) return null;
    try {
      var parsed = JSON.parse(el.textContent);
      return parsed && parsed.length ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function sync(scope) {
    if (!scope) return;
    var matrix = readMatrix(scope);
    if (!matrix) return;
    var picker = scope.querySelector('variant-selects') || scope;
    var groups = Array.prototype.slice.call(picker.querySelectorAll('fieldset'));
    if (!groups.length) return;
    if (matrix.some(function (v) { return !v.options || v.options.length !== groups.length; })) return;

    var values = groups.map(function (g) {
      var c = g.querySelector('input[type="radio"]:checked');
      return c ? c.value : null;
    });

    groups.forEach(function (group, index) {
      var inputs = Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]'));
      if (!inputs.length) return;

      var firstValid = null;
      inputs.forEach(function (input) {
        var ok = matrix.some(function (v) {
          if (v.options[index] !== input.value) return false;
          for (var j = 0; j < index; j++) {
            if (values[j] !== null && v.options[j] !== values[j]) return false;
          }
          return true;
        });
        // The first group is never filtered: every model must stay choosable.
        if (index > 0) {
          input.classList.toggle('bm-opt-hidden', !ok);
          var label = group.querySelector('label[for="' + cssEscape(input.id) + '"]');
          if (label) label.classList.toggle('bm-opt-hidden', !ok);
        }
        if (ok && !firstValid) firstValid = input;
      });

      var current = group.querySelector('input[type="radio"]:checked');
      var currentHidden = current && current.classList.contains('bm-opt-hidden');
      if (index > 0 && firstValid && (!current || currentHidden)) {
        if (current) current.checked = false;
        firstValid.checked = true;
        current = firstValid;
      }
      values[index] = current ? current.value : null;

      var readout = group.querySelector('[data-selected-value]');
      if (readout && values[index]) readout.textContent = values[index];
    });
  }

  function cssEscape(value) {
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  // Capture phase on document: runs before variant-selects' own change handler,
  // so the corrected combination is what gets fetched.
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;
    if (!target.matches('variant-selects input[type="radio"]')) return;
    sync(scopeOf(target));
  }, true);

  function syncAll() {
    document.querySelectorAll('[data-bm-variant-matrix]').forEach(function (el) {
      sync(scopeOf(el));
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      syncAll();
    });
  }

  function start() {
    syncAll();
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes && records[i].addedNodes.length) {
          schedule();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
